import styled from 'styled-components/macro';

import ButtonIcon from 'components/ButtonIcon/ButtonIcon';
import FlexContainer from 'components/FlexContainer/FlexContainer';
import Input from 'components/Input/Input';

export const HeaderStyled = styled.header`
  background-color: ${({ theme }): string => theme.colors.backgroundDefault};
  white-space: nowrap;
  margin: 0;
  padding: 5px 0 0;
`;

export const FlexContainerStyled = styled(FlexContainer)`
  flex-direction: column;
  justify-content: center;
  align-items: start;
  padding: 0;

  ${({ theme }): string => `
    ${theme.devices.desktop} {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  `}
`;

export const MobileContainerStyled = styled(FlexContainer)`
  width: 100%;
  min-width: 0;
  ${({ theme }): string => `
    ${theme.devices.tablet} {
     width: auto;
    }
  `}
`;

export const SearchAndFiltersRowStyled = styled(FlexContainer)`
  width: 100%;
  min-width: 0;
  gap: 0.5rem;
  align-items: center;
  flex-wrap: wrap;
  padding-left: 4px;
  padding-bottom: 4px;
  box-sizing: border-box;

  ${({ theme }): string => `
    ${theme.devices.desktop} {
      flex-wrap: nowrap;
    }
  `}

  @media screen and (max-width: 768px) {
    flex-direction: row;
    flex-wrap: nowrap;
    & > *:first-child {
      flex: 1;
      min-width: 0;
    }
    & > *:not(:first-child) {
      flex: 0 0 auto;
      min-width: 0;
    }
  }

  @media screen and (max-width: 425px) {
    & > *:not(:first-child) {
      margin-left: -12px;
    }
  }
`;

export const SearchBarWrapStyled = styled.div`
  position: relative;
  height: 36px;
  max-height: 36px;
  display: flex;
  align-items: stretch;
  min-width: 0;
  flex-shrink: 0;
  width: 100%;

  ${({ theme }): string => `
    ${theme.devices.largeDesktop} {
      max-width: 240px;
    }
  `}

  & > div {
    height: 100%;
    min-height: 0;
    display: flex;
    align-items: stretch;
    flex: 1;
    min-width: 0;
  }

  & input {
    height: 100% !important;
    min-height: 0;
    padding-top: 6px !important;
    padding-bottom: 6px !important;
    box-sizing: border-box;
    line-height: 1.25;
  }
`;

export const BtnFlexContainerStyled = styled(FlexContainer)`
  gap: 8px;
  flex-wrap: wrap;
  padding-right: 24px;
  padding-bottom: 4px;

  @media screen and (max-width: 768px) {
    justify-content: flex-end;
    margin-left: 0;
  }

  ${({ theme }): string => `
    ${theme.devices.desktop} {
      justify-content: space-between;
      flex-wrap: nowrap;
    }
  `}
`;

export const InputStyled = styled(Input)`
  max-width: 100%;
  width: 100%;
  min-width: 0;
  padding-left: 2rem;
  padding-right: 1.75rem;

  ${({ theme }): string => `
    ${theme.devices.largeDesktop} {
      max-width: 240px;
      width: auto;
    }
  `}
  ${({ theme }): string => `
    ${theme.devices.largeDesktop} {
      margin: 0;
    }
  `}
`;

export const ClearBtnIconStyled = styled(ButtonIcon)`
  @media (hover: hover) {
    &:hover {
      background-color: ${({ theme }): string => theme.colors.transparent};

      svg path {
        fill: ${({ theme }): string => theme.colors.primary.variant1};
      }
    }
  }
`;

export const ClearBtnWrapStyled = styled(FlexContainer)`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
`;

export const FilterChipsRowStyled = styled(FlexContainer)`
  width: 100%;
  min-width: 0;
  padding-left: 4px;
  padding-bottom: 4px;
  box-sizing: border-box;
  order: 2;
  flex-wrap: wrap;
  align-items: center;
`;

export const MobileHeaderRowStyled = styled(FlexContainer)`
  width: 100%;
  min-width: 0;
  gap: 0.5rem;
  align-items: center;
  flex-wrap: nowrap;
  padding-left: 4px;
  padding-bottom: 4px;
  box-sizing: border-box;

  @media screen and (min-width: 426px) and (max-width: 768px) {
    flex-direction: row;
    & > *:first-child {
      flex: 1;
      min-width: 0;
    }
    & > *:last-child {
      flex: 0 0 auto;
      margin-left: auto;
    }
  }

  @media screen and (max-width: 425px) {
    flex-direction: column;
    align-items: stretch;
    & > *:first-child {
      flex: 1;
      min-width: 0;
    }
    & > *:last-child {
      flex: 0 0 auto;
      align-self: flex-end;
    }
  }

  ${({ theme }): string => `
    ${theme.devices.desktop} {
      flex-direction: row;
      align-items: center;
    }
  `}
`;
